var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-container"},[_c('legend',[_vm._v(_vm._s(_vm.legend))]),_c('InputDate',{attrs:{"modelValue":_vm.modelValue,"disabled":_vm.disabled,"minDate":_vm.minDate,"maxDate":_vm.maxDate},on:{"update:modelValue":function($event){return _vm.$emit('update:modelValue', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }